import React from 'react';
import { Outlet } from 'react-router-dom';
import './I3Coaching.css';

/** Standalone public site for The Bridge — intro + video in app shell. */
const I3CoachingLayout: React.FC = () => <Outlet />;

export default I3CoachingLayout;
